/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_PassageInputs */

const en_pronunciation_report_passage = /** @type {(inputs: Pronunciation_Report_PassageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current passage`)
};

const es_pronunciation_report_passage = /** @type {(inputs: Pronunciation_Report_PassageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasaje actual`)
};

/**
* | output |
* | --- |
* | "Current passage" |
*
* @param {Pronunciation_Report_PassageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_passage = /** @type {((inputs?: Pronunciation_Report_PassageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_PassageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_passage(inputs)
	return en_pronunciation_report_passage(inputs)
});